<!--
 * @Description: 
 * @Author: GJ
 * @Date: 2019-08-19 17:00
 * @LastEditors: SYY 188842798@qq.com
 -->

<!-- 树打包组件，具体例子在maintenance/view中有实例 -->
<template>
  <div>
    <a-tree
      ref="myTree"
      v-if="treeData != null"
      :treeData="treeData"
      style="overflow: auto;height:calc(100vh - 225px)"
      @select="onSelect"
      :expandedKeys.sync="expandArray"
      :selectedKeys.sync="selectedKeys"
    >
    </a-tree>
  </div>
</template>

<script>
export default {
  props: {
    option: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      treeData: [],
      //默认展开数组，获取所有有子数组的选项的Id，用于自动展开树
      expandArray: [],
      //树选择数组，用于存储当前树选择的选项Id
      selectedKeys: [],
      //特殊选项数组，用于特殊选项
      specialArray: []
    };
  },
  created() {
    var _this = this;
    this.$post(_this.option.api, _this.option.params).then(res => {
      _this.expandArray = [];
      //获取树数据
      var tableData = res[_this.option.dataField];
      _this.buildTree(
        tableData,
        _this.option.title,
        _this.option.children,
        _this.option.keyValue
      );

      //如果有额外选项，则将选项存入树数据中
      if (_this.option.extraTreeData) {
        tableData.unshift(_this.option.extraTreeData);
      }

      //根据Id筛选出特殊选项数组
      _this.specialArray = [];
      for (let i = 0; i < tableData.length; i++) {
        if (tableData[i].Code == "SysParam") {
          var specialItem = tableData[i][_this.option.children];
          for (let l = 0; l < specialItem.length; l++) {
            _this.specialArray.push(specialItem[l]);
          }
        }
      }

      _this.treeData = tableData;

      _this.findFirstCheck(
        tableData,
        _this.option.children,
        _this.option.keyValue
      );
      var spState2 = _this.onCheckSpecial(_this.selectedKeys[0]);
      let item = { treeSelect: _this.selectedKeys[0], specialMode: spState2 };
      _this.$emit("selectedTree", item);
    });
  },
  methods: {
    //将输出数据整理成树所需数据格式
    buildTree(basicData, titleField, childrenField, keyField) {
      var _this = this;
      for (let i = 0; i < basicData.length; i++) {
        let basicData_i = basicData[i];
        // var basicData_i = basicData[i];
        basicData_i.title = basicData_i[titleField]; //设定标题对应字段
        basicData_i.key = basicData_i[keyField]; //设定选择值对应字段
        basicData_i.scopedSlots = { title: "title" };
        let children = basicData_i[childrenField]; //设定子数组对应字段
        //当子数组存在时，选择执行此函数整理数据
        if (children != undefined) {
          //将有子数组选项的Id存入默认展开数组
          _this.expandArray.push(basicData[i].Code);
          basicData[i].children = children;
          _this.buildTree(
            basicData[i][childrenField],
            titleField,
            childrenField,
            keyField
          );
        }
      }
    },
    //获取树创建时第一个被选择的选项
    findFirstCheck(Array, children, keyValue) {
      var _this = this;
      var Array_i = Array[0];
      var changeChildren = Array_i[children];
      //parentMode:选择第一个父节点的Id为被选项，childrenMode:选择第一个父节点（有子节点的父节点）的子节点的Id为被选项
      if (_this.option.checkMode == "parentMode") {
        _this.selectedKeys.push(Array_i[keyValue]);
      } else if (_this.option.checkMode == "childrenMode") {
        //如果该子节点仍然有子节点就逐层深入寻找最深层第一个子节点
        if (changeChildren != undefined) {
          _this.findFirstCheck(Array_i[children], children, keyValue);
        } else {
          _this.selectedKeys.push(Array_i[keyValue]);
        }
      }
    },
    //返回所选节点的值和模式
    onSelect(e) {
      if (e.length != 0) {
        var treeSelect = e[0];
        var _this = this;

        //避开不可选项，不可选选项为有子选项的父节点
        var unableTree = _this.expandArray;
        for (let i = 0; i < unableTree.length; i++) {
          if (treeSelect == unableTree[i]) {
            return;
          }
        }
        var spState = _this.onCheckSpecial(e[0]);
        var item = { treeSelect: treeSelect, specialMode: spState };
        this.$emit("selectedTree", item);
      }
    },

    //判断是否为特殊数组
    onCheckSpecial(node) {
      var state = false;
      for (let i = 0; i < this.specialArray.length; i++) {
        if (node == this.specialArray[i].Code) {
          state = true;
        }
      }
      return state;
    },
    resetSelect() {
      this.selectedKeys = [];
    }
  }
};
</script>

<style lang="less" scoped></style>
